import { useState, type ReactNode } from 'react';

export function Tabs({ tabs }: { tabs: { key: string; label: string; content: ReactNode }[] }) {
  const [active, setActive] = useState(tabs[0]!.key);
  return (
    <div>
      <div role="tablist" className="flex gap-1 border-b mb-4">
        {tabs.map((t) => (
          <button key={t.key} role="tab" aria-selected={active === t.key}
            onClick={() => setActive(t.key)}
            className={`px-4 py-2 ${active === t.key ? 'border-b-2 border-primary text-primary' : 'text-ink/60'}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div role="tabpanel">{tabs.find((t) => t.key === active)?.content}</div>
    </div>
  );
}
